
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M322.783 9.783v123.782h123.782z"}}),_c('path',{attrs:{"d":"M306.087 166.957c-9.217 0-16.696-7.479-16.696-16.696V0H72.348c-9.217 0-16.696 7.479-16.696 16.696v478.609c0 9.217 7.479 16.696 16.696 16.696h367.304c9.217 0 16.696-7.479 16.696-16.696V166.957H306.087zm-33.391 244.869H139.13c-9.217 0-16.696-7.479-16.696-16.696s7.479-16.696 16.696-16.696h133.565c9.217 0 16.696 7.479 16.696 16.696s-7.478 16.696-16.695 16.696zm100.174-66.783H139.13c-9.217 0-16.696-7.479-16.696-16.696s7.479-16.696 16.696-16.696h233.74c9.217 0 16.696 7.479 16.696 16.696s-7.479 16.696-16.696 16.696zm0-66.782H139.13c-9.217 0-16.696-7.479-16.696-16.696 0-9.217 7.479-16.696 16.696-16.696h233.74c9.217 0 16.696 7.479 16.696 16.696-.001 9.217-7.479 16.696-16.696 16.696z"}})])
          )
        }
      }
    